<template>
  <v-app>
    <!-- ********** Headers ********** -->
    <Header :menu="0" :breadcrumbs="breadcrumbs" v-if="menu == 0" />
    <HeaderCS :breadcrumbs="breadcrumbs" v-if="menu == 1" />
    <HeaderCustom :breadcrumbs="breadcrumbs" v-if="menu == 2" />

    <!-- ********** /Headers********** -->

    <!-- **********General content********** -->
    <v-content>
            
      <router-view @update="actualizar" @updateStatus="updateBreadcrumbs"></router-view>

    </v-content>
    <!-- **********/General content********** -->

    <!-- **********Footer********** -->
    <Footer v-if="menu == 0"/>
    <FooterCS v-if="menu == 1" />
    <FooterCustom v-if="menu == 2" />

    <!-- **********/Footer********** -->
  </v-app>
</template>

<script>


export default {
  name: 'App',

  components: {
    Header: () => import('./components/Header'),
    HeaderCS: () => import('./components/HeaderCS'),
    HeaderCustom: () => import('./components/HeaderCustom'),
    Footer: () => import('./components/Footer'),
    FooterCS: () => import('./components/FooterCS'),
    FooterCustom: () => import('./components/FooterCustom')
  },

  data: () => ({
    //menu
    menu: 0,
    breadcrumbs: [
      {
        link: '/',
        text: 'Home',
        isLink: true
      },
      {
        link: '/furniture',
        text: 'Furniture',
        isLink: true
      }
    ]
  }),
  methods:{
    actualizar(x){
      this.menu = x;
    },
    updateBreadcrumbs: function(breadcrumbs){
      this.breadcrumbs = breadcrumbs;
    }
  },
};
</script>
